import React, { useState, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import BusinessBlock from "../components/BusinessBlock";
import { Link } from "react-router-dom";
import { Spinner, Accordion, Card } from "react-bootstrap";
import CustomHelmet from "../components/CustomHelmet";
import axios from "axios";
import Pagination from "../components/Pagination";

const url = "https://www.hubsquares.com/php_files/fetchLisiting.php";
const increaseUrl = "https://www.hubsquares.com/php_files/processAnalytic.php";
export default function Listing(props) {
  const business = [
    "Food and drinks Hub",
    "Catering and Restaurants Hub",
    "Hair products and Hair styling Hub",
    "Automobile Services",
    "Makeup and Skincare Hub",
    "Photography Hub",
    "Fabrics and Tailoring Hub",
    "Courier services Hub",
    "Event planners Hub",
    "Educational Services Hub",
    "Art and Crafts Hub",
    "Books and Authors Hub",
    "Property and Accommodation Hub",
    "Laundry and Cleaning Services Hub",
    "Fashion and Accessories Hub",
    "Tech and Electronics Hub",
    "Health and fitness Hub",
    "Home and decor Hub",
    "Gifting and personal shopping Hub",
    "Legal Services Hub",
    "Accounting Services Hub",
  ];
  const [city, setCity] = useState("");
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);
  const [service, setService] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const [keyword, setKeyword] = useState("");
  useEffect(() => {
    const fetchListing = () => {
      axios.get(url).then((res) => {
        if (res.data.listing) {
          let approvedList = res.data.listing.filter(
            (lis) => lis.status === "approved"
          );
          setListings(approvedList);
        }
        setLoading(false);
      });
    };
    fetchListing();
  }, []);

  function increaseCounter(ref) {
    axios.post(increaseUrl, { refID: ref });
  }

  useEffect(() => {
    window.scrollTo(0, 500);
    if (props.match.params.service || props.match.params.service) {
      setCity(props.match.params.city);
      setService(props.match.params.service);
    }
  }, [props.match.params]);
  const renderListing = () => {
    if (service && !city) {
      return listings
        .filter(
          (listing) =>
            listing.category === service &&
            (keyword === "" || listing.description.includes(keyword))
        )
        .map((business, i) => (
          <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
            <div className="text-dark">
              <BusinessBlock
                increaseCounter={() => increaseCounter(business.refID)}
                title={business.title}
                rating={business.rating}
                ratingNumber=""
                refID={business.refID}
                to={`/listing-details/${business.refID}`}
                category={business.category}
                details={business.googleaddress}
                img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                city={
                  business.package !== "Basic plan" ? business.phone : "Hidden"
                }
              />
            </div>
          </div>
        ));
    } else if ((!service || service === " ") && city) {
      return listings
        .filter(
          (listing) =>
            listing.state.toLowerCase().includes(city.toLowerCase()) ||
            listing.country.toLowerCase().includes(city.toLowerCase()) ||
            (listing.googleaddress.toLowerCase().includes(city.toLowerCase()) &&
              (keyword === "" || listing.description.includes(keyword)))
        )
        .map((business, i) => (
          <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
            <div className="text-dark">
              <BusinessBlock
                increaseCounter={() => increaseCounter(business.refID)}
                title={business.title}
                rating={business.rating}
                ratingNumber=""
                refID={business.refID}
                to={`/listing-details/${business.refID}`}
                category={business.category}
                details={business.googleaddress}
                img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                city={
                  business.package !== "Basic plan" ? business.phone : "Hidden"
                }
              />
            </div>
          </div>
        ));
    } else if (service && city) {
      return listings
        .filter(
          (listing) =>
            listing.category.includes(service) &&
            listing.googleaddress.toLowerCase().includes(city.toLowerCase()) &&
            (keyword === "" || listing.description.includes(keyword))
        )
        .map((business, i) => (
          <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
            <div className="text-dark">
              <BusinessBlock
                increaseCounter={() => increaseCounter(business.refID)}
                title={business.title}
                rating={business.rating}
                ratingNumber=""
                refID={business.refID}
                to={`/listing-details/${business.refID}`}
                category={business.category}
                details={business.googleaddress}
                img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                city={
                  business.package !== "Basic plan" ? business.phone : "Hidden"
                }
              />
            </div>
          </div>
        ));
    } else {
      return listings
        .filter((listing) => listing.description.includes(keyword))
        .map((business, i) => (
          <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
            <div className="text-dark">
              <BusinessBlock
                increaseCounter={() => increaseCounter(business.refID)}
                title={business.title}
                rating={business.rating}
                ratingNumber=""
                refID={business.refID}
                to={`/listing-details/${business.refID}`}
                category={business.category}
                details={business.googleaddress}
                img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                city={
                  business.package !== "Basic plan" ? business.phone : "Hidden"
                }
              />
            </div>
          </div>
        ));
    }
  };
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = listings.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNum) => {
    setCurrentPage(pageNum);
    window.scrollTo(0, 420);
  };

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    window.scrollTo(0, 420);
  };

  const prevPage = () => {
    setCurrentPage(currentPage - 1);
    window.scrollTo(0, 420);
  };
  return (
    <div>
      <CustomHelmet page="All Businesses" />
      <Navbar user={props.user} />
      <div className="wrapper position-relative mh-new banner3">
        <div className="overlay">
          <div className="banner">
            <div className="content text-left mt-6 container">
              {service ? (
                <h1>
                  <span className="font-weight-normal">Result for:</span>{" "}
                  {service}
                </h1>
              ) : (
                <h1>Businesses</h1>
              )}
            </div>
          </div>
        </div>
      </div>

      <main className="container px-4">
        <div className="mt-4 row">
          <div className="col-md-3"></div>
          <div className="form-group col-md-6">
            <input
              type="text"
              className="form-control form-control-lg input_2"
              placeholder="Search Product"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="offering row">
          <div className="col-md-4  p-0 my-5">
            <Accordion defaultActiveKey="0">
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  onClick={() => setOpen(!open)}
                  eventKey="0"
                >
                  Categories{" "}
                  <span
                    className="fs-24"
                    style={{ float: "right", fontWeight: "800" }}
                  >
                    {open ? "+" : "-"}
                  </span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className="px-0">
                    {business
                      .sort((item1, item2) => (item1 > item2 ? 1 : -1))
                      .map((item) => (
                        <Link
                          key={item}
                          className="log-out d-block py-2 px-3 text-decoration-none text-dark"
                          style={{
                            backgroundColor:
                              props.match.params.service === item
                                ? "#ccc"
                                : null,
                          }}
                          to={`/listing/service=${item}`}
                        >
                          {item}{" "}
                          <span style={{ fontWeight: "800" }}>
                            (
                            {listings.filter((s) => s.category === item).length}
                            )
                          </span>
                        </Link>
                      ))}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
          <div className="col-md-8 col-sm-12">
            <div className="row mt-5 mb-3 align-items-center justify-content-center">
              {!loading ? (
                props.match.params.service || props.match.params.city ? (
                  <div className="row mt-5 mb-3 align-items-center justify-content-center">
                    {renderListing()}
                  </div>
                ) : (
                  <div className="row mt-5 mb-3 align-items-center container-sm  justify-content-center">
                    {currentPosts
                      .filter((listing) =>
                        listing.description.includes(keyword)
                      )
                      .map((business, i) => (
                        <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
                          <div className="text-dark">
                            <BusinessBlock
                              increaseCounter={() =>
                                increaseCounter(business.refID)
                              }
                              title={business.title}
                              rating={business.rating}
                              ratingNumber=""
                              refID={business.refID}
                              to={`/listing-details/${business.refID}`}
                              category={business.category}
                              details={business.googleaddress}
                              img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                              city={
                                business.package !== "Basic plan"
                                  ? business.phone
                                  : "Hidden"
                              }
                            />
                          </div>
                        </div>
                      ))}
                    <Pagination
                      postsPerPage={postsPerPage}
                      totalPosts={listings.length}
                      paginate={paginate}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      current={currentPage}
                    />
                  </div>
                )
              ) : (
                <>
                  {" "}
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                  <br />
                </>
              )}
              <div className="fs-24 text-uppercase text-bold">
                {!loading && renderListing().length < 1 ? (
                  <h4>No business available</h4>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="position-relative mb-5">
          <button
            className="text-white addbtn btn-danger btn  position-absolute bg-red"
            style={{
              right: 0,
            }}
            onClick={() => window.scrollTo(0, 0)}
          >
            Back to top
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}
